<template>
    <div class="container text-dark block">
        <div class="modal fade" id="warning_popup" tabindex="-1" role="dialog" aria-labelledby="warning_popup_label" data-backdrop="static" data-keyboard="false" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content" style="border: 0px">
                    <div class="modal-header" style="background-color: #F2A143; border-color: #F2A143; padding-left: 45%">
                        <i class="fas fa-exclamation-circle text-white" style="font-size: 55px;"></i>
                    </div>
                    <div class="modal-body container text-center" style="background-color: #ffffff">
                        <h3>Waarschuwing!</h3>
                        <p>De volgende gekoppelde verlofuren zullen ook veranderen.</p>
                        <ul v-if="absence != null && absence.connected_ranges != null" class="list-group" style="height: 75px; overflow: auto;">
                            <li v-for="(range) of absence.connected_ranges" v-bind:key="range.id" class="list-group-item pt-0 pb-0" style="border: none;">
                                <i>{{ range.start_date }} {{ range.start_time }} - {{ range.start_date }} {{ range.end_time }}</i>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer h2" style="background-color: #ffffff">
                        <i class="fas fa-check text-success mr-4" @click="acceptChange"></i>
                        <i class="fas fa-times text-danger mr-3" @click="cancelChange"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            absence: Object,
            value: Number,
            oldValue: Number,
            type: Boolean,
        },
        methods: {
            /**
             * 
             * Events
             * 
             */
            acceptChange() {
                if (!this.type) {
                    this.$emit('changeStatus', this.value, this.absence.absence_id);
                } else if(this.type) {
                    this.$emit('changeNotCharged', this.value, this.absence.absence_id);
                }
                $('#warning_popup').modal('hide');
            },
            cancelChange() {
                if (!this.type) {
                    this.$emit('cancelStatus', this.oldValue, this.absence.absence_id);
                } else if(this.type) {
                    this.$emit('cancelNotCharged', this.oldValue, this.absence.absence_id);
                }
                $('#warning_popup').modal('hide');
            }
        },
    }
</script>
